// Chilean RUT validation utilities (frontend mirror).
export function cleanRut(rut) {
  if (!rut) return "";
  return rut.replace(/[^0-9kK]/g, "").toUpperCase();
}

export function calculateDV(num) {
  let total = 0;
  const factors = [2, 3, 4, 5, 6, 7];
  const reversed = num.toString().split("").reverse();
  reversed.forEach((d, i) => {
    total += parseInt(d, 10) * factors[i % 6];
  });
  const mod = 11 - (total % 11);
  if (mod === 11) return "0";
  if (mod === 10) return "K";
  return String(mod);
}

export function validateRut(rut) {
  const cleaned = cleanRut(rut);
  if (cleaned.length < 2) return false;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  if (!/^\d+$/.test(body)) return false;
  return calculateDV(body) === dv;
}

export function formatRut(rut) {
  const cleaned = cleanRut(rut);
  if (cleaned.length < 2) return rut;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  const reversed = body.split("").reverse().join("");
  const chunks = reversed.match(/.{1,3}/g) || [];
  const formattedBody = chunks.join(".").split("").reverse().join("");
  return `${formattedBody}-${dv}`;
}
